import * as Yup from "yup";

export const colorSchema = Yup.string().matches(/^#(?:[0-9a-f]{3}){1,2}$/i, "Invalid color code");

export const isColor = (value: unknown): value is string => {
  return colorSchema.isValidSync(value);
};
